export default __webpack_public_path__ + "static/media/login-bg.287153f7.jpg";